import React, { useState } from "react";
import { Form } from "antd";
import "antd/dist/antd.css";
import { CheckCircleOutlined, StopOutlined, ReloadOutlined } from "@ant-design/icons";

import Container from "@components/Container";
import Row from "@components/Row";
import DefaultInput from "@components/DefaultInput";
import SubmitButton from "@components/SubmitButton";

import LogisticService from "@LogisticService";

import { Span, TextError, TextSuccess } from "../styles";

export default function RepiqueOS() {
  const [successfully, setSuccessfully] = useState("wait");
  const [form] = Form.useForm();

  const onFinish = async (data) => {
    try {
      const response = await LogisticService.postRepiqueOS({
        numero_os: data.numero_os,
      });

      if (response && response.status === 200) {
        setSuccessfully("ok");
        form.resetFields();
        setTimeout(() => {
          setSuccessfully("wait");
        }, 3000);
      } else {
        setSuccessfully("erro");
        setTimeout(() => {
          setSuccessfully("wait");
        }, 3000);
      }
    } catch (error) {
      setSuccessfully("erro");
      setTimeout(() => {
        setSuccessfully("wait");
      }, 3000);
    }
  };

  return (
    <Container
      grid={1}
      title={
        <>
          <ReloadOutlined style={{ marginRight: 8 }} />
          Repique de OS
        </>
      }
      padding={"0 16px 16px 16px"}
      rounded={true}
      margin={"1rem"}
    >
      <Row>
        <Span>
          Essa funcionalidade irá repicar a OS informada, recalculando a data
          limite e data limite cliente com base no SLA da cartografia.
        </Span>
      </Row>
      <Form onFinish={onFinish} form={form}>
        <Row horizontalAlign={"left"} verticalAlign={"center"}>
          <Form.Item
            name="numero_os"
            label="Número da OS"
            labelCol={{ span: 24 }}
            rules={[{ required: true, message: "Informe o número da OS!" }]}
          >
            <DefaultInput
              type={"Number"}
              min={0}
              placeholder={"Ex: 123456"}
              style={{ width: "220px" }}
            />
          </Form.Item>
          <SubmitButton
            verifyer={successfully}
            textSuccess="OS Repicada Com Sucesso! （っ＾▿＾）"
            textError="Falha Ao Repicar a OS! ( ˘︹˘ )"
          >
            REPICAR OS
          </SubmitButton>
        </Row>
      </Form>
    </Container>
  );
}
